import { Component, inject, OnDestroy, Signal } from '@angular/core';
import { stages } from '../../response-to-call.routes';
import { Store } from '@ngrx/store';
import {
  selectApplication,
  selectLoading,
  selectPending
} from '../../../../../../store/selectors/application.selectors';
import { ApplicationAppEntityApplicationRead } from '../../../../../../openapi';
import { ActivatedRoute, Router } from '@angular/router';
import { ResponseToCallAnswerForm } from './forms/response-to-call-answer.form';
import { Subscription } from 'rxjs';
import { toObservable } from '@angular/core/rxjs-interop';
import { updateApplication } from '../../../../../../store/actions/application.actions';
import { StagesComponent } from '../../../../../../common/stages/stages.component';
import { SpinnerComponent } from '../../../../../../common/spinner/spinner.component';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ValidationErrorsComponent } from '../../../../../../common/validation-errors/validation-errors.component';

@Component({
  selector: 'app-response-to-call-answer-section',
  standalone: true,
  imports: [
    StagesComponent,
    SpinnerComponent,
    ReactiveFormsModule,
    CommonModule,
    ValidationErrorsComponent
  ],
  providers: [ResponseToCallAnswerForm],
  templateUrl: './response-to-call-answer-section.component.html'
})
export class ResponseToCallAnswerSectionComponent implements OnDestroy {

  public stages: string[] = stages;

  private store$: Store = inject(Store);

  private route: ActivatedRoute = inject(ActivatedRoute);

  public successUrl: string = this.route.snapshot.data['successUrl'];

  private router: Router = inject(Router);

  public form: ResponseToCallAnswerForm = inject(ResponseToCallAnswerForm);

  public pending: Signal<boolean> = this.store$.selectSignal(selectPending);

  public loading: Signal<boolean> = this.store$.selectSignal(selectLoading);

  public application: Signal<ApplicationAppEntityApplicationRead | null> = this.store$.selectSignal(selectApplication);

  private fetchApplication: Subscription = toObservable(this.application).subscribe(app => {
    if (app) {
      this.form.patchFormValues(app);
    }
  });

  public submitAndGoNext(): void {
    if (this.form.valid) {
      this.store$.dispatch(updateApplication({
        id: this.application()?.uuid || '',
        application: this.form.value,
        successFnc: (application) => {
          this.router.navigate(
            [this.successUrl],
            {
              relativeTo: this.route
            }
          );
        },
        failureFnc: () => {
        }
      }));
    } else {
      this.form.markAllAsTouched();
    }
  }

  public onCancel(): void {
    this.router.navigate(['../dane-wniosku'], { relativeTo: this.route });
  }

  public ngOnDestroy(): void {
    this.fetchApplication.unsubscribe();
  }
}
